export interface IFunctionalForm {
  DisplayOrder: number;
  Name: string;
  Index: number;
}

export const functionalForms: IFunctionalForm[] = [
  { DisplayOrder: 0, Name: 'Polynomial 1st', Index: 1 },
  { DisplayOrder: 1, Name: 'Polynomial 2nd', Index: 2 },
  { DisplayOrder: 2, Name: 'Polynomial 3rd', Index: 3 },
  { DisplayOrder: 3, Name: 'Polynomial 4th', Index: 4 },
  { DisplayOrder: 4, Name: 'Polynomial 5th', Index: 5 },
  { DisplayOrder: 5, Name: 'Polynomial 6th', Index: 6 },
  { DisplayOrder: 6, Name: 'Bullet', Index: 7 },
  { DisplayOrder: 7, Name: 'Linear', Index: 8 },
  { DisplayOrder: 8, Name: 'Exponential', Index: 9 },
  { DisplayOrder: 9, Name: 'LogNormal', Index: 10 },
  { DisplayOrder: 10, Name: 'Power', Index: 11 },
  { DisplayOrder: 11, Name: 'Beta', Index: 12 }
];

export const functionalFormsDecay: IFunctionalForm[] = [
  { DisplayOrder: 0, Name: 'Bullet', Index: 7 },
  { DisplayOrder: 1, Name: 'Linear', Index: 8 },
  { DisplayOrder: 2, Name: 'Poly2nd', Index: 2 },
  { DisplayOrder: 3, Name: 'Exponential', Index: 9 },
  { DisplayOrder: 4, Name: 'LogNormal', Index: 10 },
  { DisplayOrder: 5, Name: 'Power', Index: 11 }
];
